var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7055 6.5C14.7055 6.22386 14.9294 6 15.2055 6H16.5959C17.354 6 18.0136 6.42177 18.3528 7.04345C18.692 6.42177 19.3515 6 20.1096 6H21.5C21.7762 6 22 6.22386 22 6.5V7C22 8.10457 21.1046 9 20 9H19.5138C19.191 11.2832 17.7046 15.1286 13.7329 15.4998H10.8151V18.0677C10.8151 18.3065 10.6216 18.5 10.3828 18.5C8.6282 18.5 7.17879 17.1932 6.95474 15.4998H6.92468C6.84266 15.4905 6.75572 15.4812 6.66461 15.4715C5.13506 15.3085 2.42883 15.0201 2.06166 12C1.57536 8.00002 4.00687 6 7.89728 6.49982C8.86988 6.5 10.7178 7.39947 12.274 8.99962C13.1707 9.76791 15.2247 10.7345 16.7594 9H16.7055C15.6009 9 14.7055 8.10457 14.7055 7V6.5ZM4.75 12.5C5.16421 12.5 5.5 12.1642 5.5 11.75C5.5 11.3358 5.16421 11 4.75 11C4.33579 11 4 11.3358 4 11.75C4 12.1642 4.33579 12.5 4.75 12.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhale);
export default __webpack_public_path__ + "static/media/whale.dc493a344af99a28450390742306ccc7.svg";
export { ForwardRef as ReactComponent };